var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_33220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9775 24C18.605 24 23.9775 18.6274 23.9775 12C23.9775 5.37258 18.605 0 11.9775 0C5.35012 0 -0.0224609 5.37258 -0.0224609 12C-0.0224609 18.6274 5.35012 24 11.9775 24Z",
    fill: "#4520E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1851 14.6488C16.1851 15.8859 15.1976 16.8921 13.9837 16.8921H9.76308L14.1494 12.4223C15.2848 12.5104 16.1851 13.4695 16.1851 14.6488H16.1851ZM9.20466 12.143V6.9747H14.1217C14.2057 6.9747 14.2885 6.97932 14.3701 6.98845L9.20468 12.143L9.20466 12.143ZM17.1796 9.25776C17.1796 8.21543 16.6688 7.29079 15.8852 6.72256L18 4.6001L16.7349 4.60734L15.0547 6.29354C14.7438 6.1887 14.411 6.13185 14.0653 6.13185H8.28121V14.3544L15.245 7.36508C15.8722 7.7605 16.2901 8.46108 16.2901 9.25774C16.2901 10.4891 15.2921 11.4906 14.0653 11.4906H13.8811L6.1333 19.2668H7.39121L8.91021 17.7423H14.0653C15.7825 17.7423 17.1796 16.3401 17.1796 14.6166C17.1796 13.4799 16.5701 12.4861 15.6639 11.9389C16.5711 11.3919 17.1796 10.395 17.1796 9.25774L17.1796 9.25776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_33220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBand);
export default __webpack_public_path__ + "static/media/band.1891db3ceb4df32da31c166b2d70ed26.svg";
export { ForwardRef as ReactComponent };